import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

const fetchUser = async () => {
  try {
    console.log("🔄 Запрос на /api/me...");
    const res = await axios.get('https://metallpererabotka.ru/api/me/', {
      withCredentials: true
    });
    console.log("✅ Получен пользователь:", res.data);
    setUser(res.data);
  } catch (err) {
    console.log("❌ Ошибка при запросе /api/me:", err);
    setUser(null);
  }
};


  useEffect(() => {
    fetchUser();
  }, []);

  const logout = async () => {
    try {
      await axios.post('https://metallpererabotka.ru/api/logout/', {}, {
        withCredentials: true
      });
    } catch (e) {
      console.error('Ошибка при logout', e);
    } finally {
      setUser(null);
      window.location.href = '/';
    }
  };


  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
